<template>
    <!-- 实物奖品弹窗 -->
    <van-dialog @open="openDialog" v-model="isVisibility" :show-confirm-button="false" :styles="{top: '100px'}"  > 
        <div class="diyModal">
            <div class="diyModalBg" :class="awardObj.bigWheelActivityType == '3' ? 'tiger-modal-bg' : 'other-modal-bg'">
                <img :src="diyModalBg[awardObj.bigWheelActivityType-1]" />
            </div>
            <div class="awardContent">
                <!-- 大转盘、盲盒、新盲盒 -->
                <div v-if="awardObj.bigWheelActivityType != '3'">
                    <!-- 大转盘、盲盒、新盲盒 - 货柜自取 -->
                    <template v-if="isSmartCabinet">
                    <p v-if="isInStock" class="award-title">恭喜您获得实物奖品一份</p>
                    <p v-else class="award-title">非常抱歉，<br>您当前中奖的奖品暂无存货</p>
                    </template>
                    <!-- 大转盘、盲盒、新盲盒 - 非货柜自取 -->
                    <template v-else>
                    <p style="font-size: 16px; color: #2592F7; padding-top: 26px;" :style="{'color': awardObj.bigWheelActivityType == '2' ? '#29231E' : '#2592f7'}">恭喜您获得</p>
                    <p v-if="!entityNoNeedGuide" class="physical-reward-name" :style="{'color': awardObj.bigWheelActivityType == '2' ? '#29231E' : '#2B94F6'}">{{ awardObj.goodsName || awardObj.rewardName }}</p>
                    </template>
                </div>
                <div v-else>
                    <!--轮盘锦鲤样式-->
                    <p class="tiger-title">恭喜您获得</p>
                </div>
                <!-- 货柜自取 -->
                <img v-if="isSmartCabinet" :src="diyModalHead[1]" class="smart-cabinet-head-img" />
                <img v-else :src="diyModalHead[awardObj.bigWheelActivityType-1]" style="width: 100%; margin: 5px 0;" />
                <!--奖品图片-->
                <!-- 货柜自取 -->
                <template v-if="isSmartCabinet">
                  <img v-if="(isInStock && awardImg)" :src="awardImg" class="smart-cabinet-img">
                  <img v-if="(!isInStock && userQrCode)" :src="userQrCode" class="smart-cabinet-qrcode">
                </template>
                <!-- 实物奖品线下核销二维码 -->
                <template v-else>
                  <div v-if="awardObj.writeOffCodeUrl && !isGuideFlag" style="width: 180px; height: 180px; margin: auto;">
                    <img :src="'data:image/png;base64,' + awardObj.writeOffCodeUrl" class="award">
                    </div>
                    <!-- 专题活动中奖  或  轮盘锦鲤 或 非预约导购 -->
                  <div v-else-if="awardObj.isBeneficial || awardObj.bigWheelActivityType == '3' || !isGuideFlag" style="width: 180px; height: 180px; margin: auto;">
                    <img v-if="awardImg" :src="awardImg" class="award">
                    </div>
                </template>
                <!--奖品名称-->
                <!-- 实物奖品-到店自提-不预约导购 -->
                <p v-if="entityNoNeedGuide" class="smart-cabinet-award-name">{{ awardObj.goodsName || awardObj.rewardName }}</p>
                <!-- 轮盘锦鲤 -->
                <p v-else-if="awardObj.bigWheelActivityType == '3'" class="tiger-award-name">{{ awardObj.goodsName || awardObj.rewardName }}</p>
                <!-- 实物奖品-货柜自取 且 有库存 -->
                <p v-if="isSmartCabinet && isInStock" class="smart-cabinet-award-name">{{ awardObj.goodsName || awardObj.rewardName }}</p>
                <!-- 实物奖品-预约导购 且 非货柜自取 -->
                <div v-if="isGuideFlag && !isSmartCabinet" :class="awardObj.bigWheelActivityType == '3' ? 'tiger-guide' : ''">
                    请预约导购后去门店领取
                </div>
                <!-- 货柜自取 且 有库存 -->
                <div v-if="isSmartCabinet && isInStock" class="pick-up-code">
                    <div class="label">取货码</div>
                    <div class="vertical-divider"></div>
                    <div class="value">{{ pickUpCode }}</div>
                </div>
                <!-- 货柜自取 且 无库存 -->
                <div v-if="isSmartCabinet && !isInStock" class="clerk-info">
                    {{ channelName }}
                </div>
            </div>
            <!-- 实物-线上邮寄：增加有效期以及对应状态 -->
            <!-- 轮盘锦鲤活动 - 实物权益品 - 线上邮寄  -->
            <div v-if="awardObj.bigWheelActivityType == '3' && awardObj.rewardType === '2' && awardObj.collectionType == '1' && awardObj.effectiveStartTime && awardObj.effectiveEndTime">
                <p style="text-align: center;">{{ '有效期：' + awardObj.effectiveStartTime + '~' + awardObj.effectiveEndTime }}</p>
            </div>
            <div class="diyReceive">
                <!-- 货柜自取 -->
                <div v-if="isSmartCabinet" class="smart-cabinet-bottom-text">
                    <template v-if="isInStock">
                        取货码有效期<span>24小时</span>，请及时前往<br>指定设备领取礼品，过期未领视为放弃领取
                    </template>
                    <template v-if="userQrCode !== ''">
                        您可以长按或截图保存上方<br>二维码，添加门店工作人员企业微信咨询
                    </template>
                </div>
                <!-- 预约导购 -->
                <div v-else-if="isGuideFlag" class="diyModalButton" :class="{'blindBoxBtn': awardObj.bigWheelActivityType == '2'}">
                    <!-- 大转盘 -->
                    <img v-if="awardObj.bigWheelActivityType == '1' && !activityObj.extendConfig.awardPopupButtonColor" src="static/runtime/images/magic/award/diyModalButton.png" />
                    <!-- 新盲盒 -->
                    <img v-if="awardObj.bigWheelActivityType == '4' && !activityObj.extendConfig.awardPopupButtonColor" src="static/runtime/images/magic/award/diyModalButton.png" />
                    <!-- 轮盘锦鲤 -->
                    <img v-if="awardObj.bigWheelActivityType == '3' && !activityObj.extendConfig.awardPopupButtonColor" :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn-img':''" src="static/runtime/images/magic/award/tiger-btn.png" />
                    <div v-if="awardObj.bigWheelActivityType == '1' && activityObj.extendConfig.awardPopupButtonColor" class="diyModalButtonBg" :style=getButtonBgStyle></div>
                    <div v-if="awardObj.bigWheelActivityType == '3' && activityObj.extendConfig.awardPopupButtonColor" class="diyModalButtonBg" :style=getButtonBgStyle></div>
                    <div v-if="awardObj.bigWheelActivityType == '2'" class="diyModalButtonBg" :style=getButtonBgStyle></div>                    
                    <!-- 实物奖品-预约导购 -->
                    <!-- 非轮盘锦鲤 -->
                    <div v-if="awardObj.bigWheelActivityType != '3'"
                        class="diyModalButtonText">确认</div>
                    <div v-else
                        class="tiger-btn diyModalButtonText">立即预约</div>
                    <!-- 跳小程序  -->
                    <!-- 已在小程序打开，点击后通过有效期校验后可打开小程序的预约导购 -->
                    <div v-if="miniFlag"
                        style="width: 200px; height: 45px; position: absolute; top:0;"
                        @click="backXcx()"></div>
                    <!-- 仍在H5页面，点击后通过有效期校验后可打开小程序，然后打开小程序的预约导购 -->
                    <div v-else
                        style="width: 100%; height: 100%; position: absolute; top: 0;"
                        @click="isValid()">
                        <wx-open-launch-weapp v-if="isAwardValid"
                            :id="'launch-btn'"
                            :env-version="env"
                            :username="hiHonorWxAppId"
                            :path="path">
                            <script type="text/wxtag-template">
                                <div style="width: 150px; height: 220px; display: block; opacity: 0; color: red; background: green;">打开小程序</div>
                        </script>
                        </wx-open-launch-weapp>
                    </div>
                </div>
                <!-- 不预约导购 -->
                 <div v-else class="diyModalButton" :class="{'blindBoxBtn': awardObj.bigWheelActivityType == '2'}">
                    <img v-if="awardObj.bigWheelActivityType == '1' && !activityObj.extendConfig.awardPopupButtonColor" src="static/runtime/images/magic/award/diyModalButton.png" />
                    <img v-if="awardObj.bigWheelActivityType == '4' && !activityObj.extendConfig.awardPopupButtonColor" src="static/runtime/images/magic/award/diyModalButton.png" />
                    <img v-if="awardObj.bigWheelActivityType == '3' && !activityObj.extendConfig.awardPopupButtonColor" :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn-img':''" src="static/runtime/images/magic/award/tiger-btn.png" />
                    <div v-if="awardObj.bigWheelActivityType == '1' && activityObj.extendConfig.awardPopupButtonColor" class="diyModalButtonBg" :style=getButtonBgStyle></div>
                    <div v-if="awardObj.bigWheelActivityType == '4' && activityObj.extendConfig.awardPopupButtonColor" class="diyModalButtonBg" :style=getButtonBgStyle></div>
                    <div v-if="awardObj.bigWheelActivityType == '3' && activityObj.extendConfig.awardPopupButtonColor" class="diyModalButtonBg" :style=getButtonBgStyle></div>
                    <div v-if="awardObj.bigWheelActivityType == '2'" class="diyModalButtonBg" :style=getButtonBgStyle></div>
                    <!-- 实物奖品-到店自提-不需要预约导购 -->
                    <div v-if="entityNoNeedGuide" class="diyModalButtonText" :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''" @click="modalOk('toStore')">确定</div>
                    <!-- 实物奖品-线上邮寄-不需要预约导购 -->
                    <div v-else class="diyModalButtonText" :class="awardObj.bigWheelActivityType == '3' ? 'tiger-btn': ''" @click="modalOk('online')">立即领取</div>
                </div>
            </div>
            <div class="diyClose" @click="modalCancel"><van-icon name="close" /></div>
        </div>
    </van-dialog>
</template>


<script>
import wx from 'weixin-js-sdk';
import { config as configEnv } from '../../../../../commons/config.js';
import { config } from '@/api/config.js';
import { Dialog, Icon, Toast } from 'vant';
import { getValidity } from '../../common-methods/utils.js';
import { ActivityType } from '../../../../../commons/commonVariables.js';
import { BigWheelConstants as BWC } from '../../lucky-draw/common/global-variable.js';
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [Icon.name]: Icon,
  },
  props: {
    awardObj: Object,
    miniFlag: Boolean,
    activityUrl: String,
    // 获取抽奖次数方式
    drawType: String,
    activityObj: Object,
    modalButtonText: String,
  },
  data() {
    return {
      isVisibility: false,
      isGuideFlag: false,
      path: '', //预约导购路径
      diyModalBg: [
        'static/runtime/images/magic/award/diyModalBg.png',
        'static/runtime/images/magic/award/awardBg2.png',
        'static/runtime/images/magic/award/tiger-bj.png',
        'static/runtime/images/magic/award/diyModalBg.png',
      ],
      diyModalHead: [
        'static/runtime/images/magic/award/zjjl_tc_bg.png',
        'static/runtime/images/magic/award/awardBg1.png',
        'static/runtime/images/magic/award/tiger-machine-head-bg.png',
        'static/runtime/images/magic/award/zjjl_tc_bg.png',
      ],
      // 取货码
      pickUpCode: '',
      // 导购个人二维码
      userQrCode: '',
      // 门店名称
      channelName: '',
      // 是否有库存
      isInStock: true,
      openSrc: '',
      env: configEnv.env === 'pro' ? 'release' : 'trial', // 判断当前环境变量，env-version默认正式版release，为方便测试增加体验版trial跳转
      isAwardValid: false,
      hiHonorWxAppId:config.otherConfig.hiHonorWxAppId,
    };
  },
  created() {},
  mounted() {},
  computed: {
    awardImg() {
      if (this.awardObj && this.awardObj.goodsPictureUrl) {
        const imgUrl = JSON.parse(this.awardObj.goodsPictureUrl).file;
        return this.$utils.getImageUrl(imgUrl);
      }
      return '';
    },
    // 是否为智能柜取货
    isSmartCabinet() {
      // collectionType值待定，目前设置为2:到店自提(实物),实际应设置为5
      // return this.awardObj.bigWheelActivityType === 2 && this.awardObj.rewardType === '2' && this.awardObj.collectionType === '5';
      return this.awardObj.collectionType === '5';
    },
    // 实物奖品-到店自提-不需要预约导购
    entityNoNeedGuide() {
      return this.awardObj.collectionType === '2' && !this.isGuideFlag;
    },
    getButtonBgStyle() {
      return {
        'background-color': this.activityObj.extendConfig.awardPopupButtonColor || '#ffffff',
      };
    },
  },

  methods: {
    async openModel(obj) {
      this.openSrc = obj.openSrc;
      this.isVisibility = true;
      this.isGuideFlag = obj.flag;
      console.log('receive-isGuideFlag', this.isGuideFlag);
      if (obj.codeId) {
        const { result } = await this.checkShoppingGuide(obj.codeId);
        // 预约导购 jumpFromH5Activ 入参区分是从h5跳转
        this.path =
          result && result.guideId
            ? `subpackages/activity/pages/shoppersService/serviceDetail/service-detail?id=${result.guideId}&activityUrl=${this.activityUrl}`
            : `subpackages/activity/pages/shoppersService/createService/create-service?jumpFromH5Activ=1&activationCodeId=${obj.codeId}&collectionType=${obj.type}&drawType=${this.drawType}&activityUrl=${this.activityUrl}`;
      }
    },
    // 打开弹出层时触发的处理函数
    openDialog() {
      console.log('receive-awardObj', this.awardObj);
      // 若为货柜取货，且是查看中奖记录时，则需要调接口查询
      if (this.awardObj.collectionType === '5' && this.openSrc === 'viewRecord') {
        this.getRewardInfo(this.awardObj.bigwheelRewardRecodeId).then((res) => {
          if (res.code === 200) {
            const result = res.result;
            this.pickUpCode = result.pickUpCode ? result.pickUpCode : '';
            this.userQrCode = result.userQrCode ? result.userQrCode : '';
            this.channelName = result.channelName ? result.channelName : '';
            this.isInStock = !result.inventoryFlag;
            this.pickUpCode = this.formatPickUpCode(this.pickUpCode);
          } else {
            Dialog.alert({
              title: '提示',
              message: res.message,
            });
          }
        });
      } else if (this.awardObj.collectionType === '5') {
        // 若为货柜取货，且是抽奖结果处理时
        this.pickUpCode = this.awardObj.pickUpCode ? this.awardObj.pickUpCode : '';
        this.userQrCode = this.awardObj.userQrCode ? this.awardObj.userQrCode : '';
        this.channelName = this.awardObj.channelName ? this.awardObj.channelName : '';
        this.isInStock = !this.awardObj.inventoryFlag;
        this.pickUpCode = this.formatPickUpCode(this.pickUpCode);
      }
    },
    getRewardInfo(bigwheelRewardRecodeId) {
      return new Promise((resolve, reject) => {
        this.$api.post({
          noLoading: true,
          sc: 'mobileMarketing',
          url: `/h5/bigWheel/getPickUpCodeShow/${bigwheelRewardRecodeId}`,
          params: null,
          success: (r) => {
            resolve(r);
          },
          failure: (err) => {
            reject(err);
          },
        });
      });
    },
    formatPickUpCode(pickUpCode) {
      if (pickUpCode !== '') {
        return pickUpCode.substring(0, 4) + ' ' + pickUpCode.substring(4);
      } else {
        return '';
      }
    },
    async modalOk(type) {
      // 实物-线上邮寄
      if (type === 'online') {
        // 实物-线上邮寄-超过有效期提示
        if (
          this.awardObj.bigWheelActivityType == '3' &&
          this.awardObj.rewardType == '2' &&
          this.collectionType == '1' &&
          this.awardObj.effectiveStartTime &&
          this.awardObj.effectiveEndTime &&
          this.awardObj.effectiveEndTime <= new Date()
        ) {
          Toast('超过领取时间，无法兑换');
          return false;
        } else {
          this.$emit('openKindAwardModal');
        }
        this.isVisibility = false;
      } else if (type === 'toStore') {
        // 实物-到店自提-无需预约导购
        let isNextToStore = true;
        try {
          const params = {
            goodsId: this.awardObj.goodsId || '',
            rewardRecodeId: this.awardObj.bigwheelRewardRecodeId || this.awardObj.rewardRecodeId || this.awardObj.recordId || '',
            activityCode: this.activityObj.activityCode || '',
          };
          // 判断实物权益品-到店自提-不预约导购 是否在有效期内
          console.log('1111111',params)
          isNextToStore = await getValidity(params, this.awardObj.bigWheelActivityType);
        } catch (err) {
          console.log(err);
        }
        if (isNextToStore) {
          // 未过期则正常关闭弹窗
          this.isVisibility = false;
        } else {
          Toast('超过领取时间，无法兑换');
        }
        if (
          this.awardObj.jumpType &&
          this.awardObj.jumpUrl &&
          this.activityObj.activityType === ActivityType.bigTurnable &&
          [BWC.DrawWheelType.ordinaryDraw, BWC.DrawWheelType.timedDraw].includes(this.activityObj.drawWheelType)
        ) {
          // 大转盘普通抽奖/定时抽奖，配置了自定义链接的，跳转下一级
          this.$emit('nextStep', this.awardObj.jumpUrl, this.awardObj.jumpType);
        }
      }
    },
    modalCancel() {
      setTimeout(() => {
        this.isVisibility = false;
      }, 300);
    },
    //h5在小程序配置的跳回小程序
    async backXcx() {
      // 判断实物权益品-预约导购 是否在有效期内
      try {
        const params = {
          goodsId: this.awardObj.goodsId || '',
          rewardRecodeId: this.awardObj.bigwheelRewardRecodeId || this.awardObj.rewardRecodeId || this.awardObj.recordId || '',
          activityCode: this.activityObj.activityCode || '',
        };
        console.log('222222',params)
        const isNext = await getValidity(params, this.awardObj.bigWheelActivityType);
        if (!isNext) {
          return;
        }
        const url = `/${this.path}`;
        wx.miniProgram.navigateTo({
          url: url,
        });
      } catch (err) {
        console.log(err);
      }
    },
    //检测是否已经预约成功了
    checkShoppingGuide(id) {
      return new Promise((resolve, reject) => {
        this.$api.get({
          noLoading: true,
          sc: 'mobileMarketing',
          url: `guide/getGuideByActivationCodeId/${id}`,
          params: null,
          success: (r) => {
            resolve(r);
          },
        });
      });
    },
    async isValid() {
      try {
        const params = {
          goodsId: this.awardObj.goodsId || '',
          rewardRecodeId: this.awardObj.bigwheelRewardRecodeId || this.awardObj.rewardRecodeId || this.awardObj.recordId || '',
          activityCode: this.activityObj.activityCode || '',
        };
        console.log('33333333',params)
        const isNext = await getValidity(params, this.awardObj.bigWheelActivityType);
        this.isAwardValid = isNext;
      } catch (err) {
        console.log(err);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.van-dialog {
  width: 92%;
  overflow: initial;
  background-color: transparent;
  .van-dialog__content {
    text-align: center;
    font-size: 14px;
    color: #333;
    width: 100%;
    margin: auto;

    .diyModal {
      width: 320px;
      // max-width: 694px;
      height: auto;
      margin: auto;
      min-height: 245px;
      padding-bottom: 125px;
      position: relative;
      z-index: 10;
      .tiger-modal-bg {
      }
      .other-modal-bg {
        img {
          height: 210px;
        }
      }
      .diyModalBg {
        width: 100%;
        height: 210px;
        border-radius: 20px;
        position: absolute;
        bottom: 0;
        z-index: -1;
        overflow: hidden;
        &::before {
          content: '';
          width: 98%;
          height: 150px;
          position: absolute;
          bottom: 1px;
          background: #ffffff;
          border-radius: 26px;
        }
        img {
          width: 100%;
          position: absolute;
          bottom: -1px;
        }
      }
      .awardContent {
        width: 95%;
        min-height: 120px;
        margin: 0 2.5%;
        background: #ffffff;
        text-align: center;
        border-radius: 20px 20px 0 0;
        .award-title {
          font-size: 16px;
          color: #29231e;
          text-align: center;
          font-weight: 600;
          padding-top: 20px;
        }
        .physical-reward-name{
          font-size: 14px; 
          color: #2B94F6; 
          margin-top: 6px;
          padding:0 5px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          /*! autoprefixer: off */
          -webkit-box-orient: vertical;
        }
        .award {
          width: 100%;
          max-width: 180px;
          max-height: 180px;
        }
        .tiger-title {
          font-family: HYQiHei-FZS;
          font-size: 18px;
          color: #29231e;
          text-align: center;
          font-weight: 400;
          padding-top: 20px;
        }
        .smart-cabinet-head-img {
          width: 253.23px;
          height: 6.65px;
        }
        .smart-cabinet-img {
          width: 100px;
          height: 100px;
          margin: 10px auto;
        }
        .smart-cabinet-qrcode {
          width: 150px;
          height: 150px;
          margin: 0 auto;
        }
        .tiger-award-name {
          font-family: HYQiHei-EZS;
          font-size: 16px;
          color: #29231e;
          text-align: center;
          font-weight: 400;
        }
        .smart-cabinet-award-name {
          font-size: 14px;
          color: #29231e;
          text-align: center;
          font-weight: 400;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          /*! autoprefixer: off */
          -webkit-box-orient: vertical;
        }
        .pick-up-code {
          width: 168.96px;
          height: 41px;
          background: #ffffff;
          border: 1px solid #c79f60;
          border-radius: 20.5px;
          display: flex;
          margin: 0 auto;
          margin-top: 5px;
          align-items: center;
          justify-content: center;
          position: relative;
          bottom: -10px;
          .label {
            font-family: HWtext-65ST;
            font-size: 12px;
            color: #666666;
            letter-spacing: 0;
            text-align: center;
            font-weight: 500;
          }
          .vertical-divider {
            width: 1px;
            height: 11px;
            background-color: rgba(151, 151, 151, 1);
            margin: 0 5px;
          }
          .value {
            font-family: PingFangSC-Semibold;
            font-size: 18px;
            color: #b27d13;
            letter-spacing: 0;
            text-align: center;
            line-height: 25.92px;
            font-weight: 600;
          }
        }
        .clerk-info {
          font-size: 12px;
          color: #a0a0a0;
          width: 170px;
          margin: 0 auto;
          position: relative;
          bottom: -15px;
        }

        .tiger-guide {
          font-family: HYQiHei-EZS;
          font-size: 14px;
          color: #d7324c;
          text-align: center;
          font-weight: 400;
        }
      }
      .smart-cabinet-bottom-text {
        font-family: PingFangSC-Regular;
        font-size: 11.52px;
        color: #b27d13;
        text-align: center;
        font-weight: 400;
        margin-top: 30px;
        span {
          font-family: PingFangSC-Semibold;
          font-size: 14px;
          color: #ff7010;
          font-weight: 600;
          margin: 0 5px;
        }
      }
      .tiger-btn {
        font-family: HYQiHei-EES;
        color: #d7324c;
        font-size: 18px;
      }
      .diyReceive {
        width: 100%;
        height: 124px;
        position: absolute;
        bottom: 0;
        display: flex;
        justify-content: center;
        align-items: center;
        .tiger-btn-img {
          width: 90% !important;
          height: 80% !important;
        }
        .diyModalButton,
        .blindBoxBtn {
          width: 200px;
          height: 45px;
          margin-top: 33px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-family: PingFangSC-Medium;
          font-size: 18px;
          color: #ffffff;
          position: relative;
          img,
          .diyModalButtonBg {
            width: 100%;
            height: 100%;
            position: absolute;
          }
          .diyModalButtonBg {
            background: #ffffff;
            border-radius: 36px;
          }
          .diyModalButtonText {
            width: 100%;
            height: 100%;
            position: absolute;
            display: flex;
            justify-content: center;
            align-items: center;
            div {
              width: 100%;
              height: 100%;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
        }
        .blindBoxBtn {
          color: #b27d13 !important;
          font-size: 16px;
          height: 36px;
        }
      }
      .diyClose {
        width: 30px;
        height: 30px;
        font-size: 36px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: -50px;
        z-index: 10000;
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/vibrantRubikCube/runtime/dynamicAttr/modal/receiveAwardModal.vue